var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-identical-expressions */
import React from 'react';
import { Button } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const AnimationLoading = () => {
    return (React.createElement("div", null,
        React.createElement("span", null, "\u2022"),
        React.createElement("span", null, "\u2022"),
        React.createElement("span", null, "\u2022")));
};
export const SmlsButton = (_a) => {
    var { id, type = 'button', color = 'primary', style, dark = false, isLoading = false, animation = true, text = '', loadingText = 'Carregando...', block = false, className = '', icon, disabled = false, onClick, onMouseDown } = _a, params = __rest(_a, ["id", "type", "color", "style", "dark", "isLoading", "animation", "text", "loadingText", "block", "className", "icon", "disabled", "onClick", "onMouseDown"]);
    return (React.createElement(Button, Object.assign({ id: id, type: type, style: style, isLoading: isLoading, text: text, color: color, block: block, className: mapToCssModules([
            className,
            color === 'hyperlink' ? 'hyperlink' : '',
            !text && icon ? 'btn-icon' : '',
            dark ? 'dark' : '',
            isLoading ? 'smls-btn-loading' : '',
            animation ? 'animation' : '',
        ]), disabled: disabled, onClick: (event) => {
            if (!isLoading && onClick) {
                onClick(event);
            }
        }, onMouseDown: (event) => {
            if (!isLoading && onMouseDown) {
                onMouseDown(event);
            }
        } }, params), color !== 'hyperlink' ? (React.createElement("span", { tabIndex: -1 },
        isLoading && animation && React.createElement(AnimationLoading, null),
        isLoading && !animation && loadingText,
        !isLoading && (React.createElement(React.Fragment, null,
            icon && icon,
            text)))) : (React.createElement(React.Fragment, null,
        icon && icon,
        text))));
};
//# sourceMappingURL=index.js.map